import { useState } from "react";
import Footer from "./Footer";
import Navbar from "./Navbar";
import { FaWhatsapp } from "react-icons/fa";

export default function Bmi() {

    const [height, setHeight] = useState("");
    const [weight, setWeight] = useState("");
    const [bmi, setBmi] = useState(null);
    const [status, setStatus] = useState("");
    const [healthyRange, setHealthyRange] = useState("");
    const [tips, setTips] = useState([]);
    const [gender, setGender] = useState("");
    const [age, setAge] = useState("");

    function calculateBMI() {

        if (!gender || !age || !height || !weight) {
            alert("Please fill all the fields.");
            return;
        }

        const heightInMeter = height / 100;

        const result = (
            weight /
            (heightInMeter * heightInMeter)
        ).toFixed(1);

        setBmi(result);

        const minWeight = (18.5 * heightInMeter * heightInMeter).toFixed(0);
        const maxWeight = (24.9 * heightInMeter * heightInMeter).toFixed(0);

        setHealthyRange(`${minWeight} - ${maxWeight} KG`);

        if (result < 18.5) {
            setStatus("Underweight");

            setTips([
                "Increase calorie intake with healthy foods",
                "Consume more protein daily",
                "Focus on strength training",
                "Sleep 7-8 hours every night"
            ]);
        }
        else if (result >= 18.5 && result < 25) {
            setStatus("Normal Weight");

            setTips([
                "Maintain your current lifestyle",
                "Train 4-5 times per week",
                "Consume adequate protein",
                "Stay hydrated throughout the day"
            ]);
        }
        else if (result >= 25 && result < 30) {
            setStatus("Overweight");

            setTips([
                "Create a moderate calorie deficit",
                "Increase daily activity",
                "Prioritize protein intake",
                "Perform cardio 3-4 times weekly"
            ]);
        }
        else {
            setStatus("Obese");

            setTips([
                "Focus on gradual fat loss",
                "Follow a structured diet plan",
                "Walk 8,000-10,000 steps daily",
                "Seek professional fitness guidance"
            ]);
        }
    }

    return (
        <>
            <title>BMI Calculator | The Fitness Expert - Calculate Your Body Mass Index</title>
            <meta name="description" content="Use The Fitness Expert's free BMI Calculator to calculate your Body Mass Index instantly. Check whether you're underweight, healthy, overweight, or obese and take the first step toward a healthier lifestyle." />
            <meta name="keywords" content="BMI calculator, body mass index calculator, calculate BMI, BMI checker, fitness calculator, weight calculator, healthy weight, obesity calculator, BMI India, online BMI calculator, free BMI calculator, The Fitness Expert" />
            <meta property="og:title" content="Free BMI Calculator | The Fitness Expert" />
            <meta property="og:site_name" content="The Fitness Expert" />
            <meta property="og:url" content="https://thefitnessexpert.in/user/Bmi" />
            <meta property="og:description" content="Calculate your Body Mass Index (BMI) for free. Find out whether you're underweight, healthy, overweight, or obese with The Fitness Expert's easy-to-use BMI Calculator." />
            <meta property="og:image" content="logo.png"></meta>
            <meta name="twitter:card" content="app" />
            <meta name="twitter:site" content="@thefitnessexpert" />
            <meta name="twitter:description" content="Calculate your Body Mass Index (BMI) for free. Find out whether you're underweight, healthy, overweight, or obese with The Fitness Expert's easy-to-use BMI Calculator." />
            <meta name="twitter:app:country" content="India" />
            <Navbar />
            <section className="py-5 bmibg">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6">
                            <div className="card border-0 shadow-lg rounded-4 bmicard">
                                <div className="card-body p-5">
                                    <h2 className="text-center text-white fw-bold mb-2">BMI Calculator</h2>
                                    <p className="text-center text-secondary mb-4">Calculate your Body Mass Index instantly</p>
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label text-white">
                                                Gender
                                            </label>

                                            <select
                                                className="form-select"
                                                value={gender}
                                                onChange={(e) => setGender(e.target.value)}
                                            >
                                                <option value="">Select Gender</option>
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                            </select>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label className="form-label text-white">
                                                Age
                                            </label>

                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Enter Age"
                                                value={age}
                                                onChange={(e) => setAge(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label text-white">Height (cm)</label>
                                        <input type="number" className="form-control" placeholder="Enter Height" value={height} onChange={(e) => setHeight(e.target.value)} />
                                    </div>
                                    <div className="mb-4">
                                        <label className="form-label text-white">Weight (kg)</label>
                                        <input type="number" className="form-control" placeholder="Enter Weight" value={weight} onChange={(e) => setWeight(e.target.value)} />
                                    </div>
                                    <button className="btn btn-danger w-100" onClick={calculateBMI}>
                                        Calculate BMI
                                    </button>
                                    {bmi && (
                                        <>
                                            <div className="text-center mt-4 p-4 rounded-4 bmidesign">
                                                <h5 className="text-white mb-2">Your BMI Score</h5>
                                                <h1 className="text-danger fw-bold display-4">{bmi}</h1>
                                                <span className={`badge fs-6 px-3 py-2 ${status === "Normal Weight" ? "bg-success" : status === "Underweight" ? "bg-warning text-dark" : "bg-danger"}`}>
                                                    {status}
                                                </span>
                                            </div>
                                            <div className="row mt-2 g-3">
                                                <div className="col-md-6">
                                                    <div className="p-3 rounded-4 bmibg2 h-100">
                                                        <small className="text-secondary">Gender</small>
                                                        <h5 className="text-info mt-2">{gender}</h5>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="p-3 rounded-4 bmibg2 h-100">
                                                        <small className="text-secondary">Age</small>
                                                        <h5 className="text-warning mt-2">{age} Years</h5>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-2 g-3">
                                                <div className="col-md-6">
                                                    <div className="p-3 rounded-4 h-100 bmibg2" >
                                                        <small className="text-secondary">Healthy Weight Range</small>
                                                        <h4 className="text-success mt-2">
                                                            {healthyRange}
                                                        </h4>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="p-3 rounded-4 h-100 bmibg2" >
                                                        <small className="text-secondary">Category</small>
                                                        <h4 className="text-info mt-2">{status}</h4>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mt-4 p-4 rounded-4 bmibg2" >
                                                <h5 className="text-white mb-3">Recommended Fitness Tips</h5>
                                                <ul className="mb-0">
                                                    {tips.map((tip, index) => (
                                                        <li key={index} className="text-light mb-2">✅ {tip}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="position-fixed bottom-0 end-0 p-3 z-3">
                <button className="fixed-join-btn text-light fw-bold px-3 py-2 shadow rounded-pill bgcolor"
                    onClick={() =>
                        window.open("https://wa.me/919876857579?text=Hello%20Harman%20Sir%20👋%0A%0AI%20visited%20your%20website%20and%20I'm%20interested%20in%20your%20fitness%20coaching%20programs.", "_blank"
                        )}>
                    <FaWhatsapp size={24} />
                </button>
            </div>
            <Footer />
        </>
    );
}